import { Tab } from '@material-ui/core';
import React from 'react';
import { $Tabs } from './styles';
export const NewTabs = ({ value, onChange, tabs, noValue, scrollable }) => {
    const handleChange = (_e, newValue) => {
        onChange(newValue);
    };
    return React.createElement($Tabs, { value: noValue ? false : value, onChange: handleChange, indicatorColor: 'primary', textColor: 'primary', variant: scrollable ? 'scrollable' : 'fullWidth', scrollButtons: scrollable ? 'auto' : undefined, centered: !scrollable }, tabs.map((tab) => React.createElement(Tab, { key: tab.id, label: tab.label })));
};
